module.exports = __webpack_public_path__ + "static/media/Maven_6520.6885558b.jpg";